import { useLocalStorage } from '@vueuse/core'

export type ContentAlign = 'center' | 'left' | 'full'

export const contentAlignValues: ContentAlign[] = ['center', 'left', 'full']

// AAR-1870: Browser-Einstellung, ob der auf --content-max-width begrenzte Inhalt
// zentriert, links an der Navigation oder gar nicht begrenzt (volle Breite) wird.
const contentAlign = useLocalStorage<ContentAlign>('contentAlign', 'center')

if (!contentAlignValues.includes(contentAlign.value)) contentAlign.value = 'center'

export const useContentAlign = () => ({ contentAlign })
